import { render, staticRenderFns } from "./addCustomers.vue?vue&type=template&id=24c1bf59&"
import script from "./addCustomers.vue?vue&type=script&lang=js&"
export * from "./addCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports